/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfReportCategoryDto } from '../../models/data-page-of-report-category-dto';

export interface ReportCategoryGetAll$Params {
  pageSize?: number;
  pageNumber?: number;
}

export function reportCategoryGetAll(http: HttpClient, rootUrl: string, params?: ReportCategoryGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfReportCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, reportCategoryGetAll.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('pageNumber', params.pageNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfReportCategoryDto>;
    })
  );
}

reportCategoryGetAll.PATH = '/api/ReportCategory/reportcategories/getalllist';
